import React from "react";
import RegistrationFormPage from "./pages/RegistrationFormPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SuccessPage from "./pages/SuccessPage";
import DashboardPage from "./pages/DashboardPage";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<RegistrationFormPage />} />
          <Route path="success" element={<SuccessPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
